<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog" [ngSwitch]="vm.status">
		<!-- Status: pending -->
		<div class="c-modal__content u-no-p@md-and-up" *ngSwitchCase="'pending'">
			<p id="searchingLabel" class="c-text c-text--center c-text--heading c-text--lg">{{ 'Booking.Instant.Pending' | translate }}</p>
			<p id="searchingTimer" class="c-text c-text--center c-text--heading c-text--lg c-text--main u-osb-md">{{ vm.timeLeft }}</p>
			<div class="o-grid o-grid--center-h u-ost-xl u-osb-xl">
				<div class="o-grid__cell o-grid__cell--w-fixed">
					<item-pie [percent]="vm.timePercentage" *ngIf="!vm.isIE"></item-pie>
					<loader-blocks *ngIf="vm.isIE"></loader-blocks>
				</div>
			</div>
			<div class="o-grid o-grid--center-h">
				<button id="cancelInstantRequestButton" type="button" class="c-button c-button--link c-button--fit"
						[ngClass]="{ ' c-button--link--softly-disabled': vm.cancellationPeriodInSeconds > 0}"
						(click)="vm.handleRequestCancel()">
					{{ 'Common.Cancel' | translate }}
				</button>
			</div>
			<div *ngIf="vm.isCancellationRequested && vm.cancellationPeriodInSeconds > 0" class="o-grid o-grid--center-h" style="margin-top: 12px">
				<p id="cancelAllowedInSecondsLabel" class="c-text c-text--center c-text--s5 u-osb-md">
					{{ ('Booking.Instant.CancellationAllowedInSeconds' | translate).replace('%s', vm.cancellationPeriodInSeconds) }}
				</p>
			</div>
		</div>
		<!-- Status: accepted -->
		<div class="c-modal__content u-no-p@md-and-up" *ngSwitchCase="'accepted'">
			<p id="waitForCallLabel" class="c-text c-text--center c-text--heading c-text--s2 c-text--lg u-osb-md@up-to-md" *ngIf="!vm.isPrescription">{{ 'Booking.Instant.Wait_For_Call' | translate }}</p>
			<p id="prescriptionStatusLabel1" class="c-text c-text--center c-text--heading c-text--s2 c-text--lg u-osb-md@up-to-md" *ngIf="vm.isPrescription">{{ 'Booking.Prescription.Accepted' | translate }}</p>
			<p class="c-text c-text--center c-text--heading c-text--s2 c-text--lg u-osb-md@up-to-md" *ngIf="vm.isPrescription">{{ 'Booking.Prescription.Accepted_Wait' | translate }}</p>
			<div class="c-content c-content--xxl u-no-pb">
				<div class="o-grid o-grid--center-h">
					<div class="o-grid__cell o-grid__cell--w-fixed">
						<loader-blocks></loader-blocks>
					</div>
				</div>
			</div>
		</div>
		<!-- Status: cancel -->
		<div class="c-modal__content u-no-p@md-and-up" *ngSwitchCase="'cancel'">
			<p id="cancelTitle" class="c-text c-text--center c-text--heading c-text--s2 c-text--lg u-osb-md@up-to-md">
				{{ 'Booking.Instant.Cancel_Title' | translate }}
			</p>
			<div class="c-content u-no-pb">
				<p class="c-text c-text--center u-osb-lg">{{ 'Booking.Instant.Cancel_Description' | translate }}</p>
				<div class="o-grid o-grid--center-h u-osb-lg">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
						<button id="cancelRedirectHome" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.handleRedirectHome()">
							{{ 'Common.Ok' | translate }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<!-- Status: repeat_pending -->
        <div class="c-modal__content u-no-p@md-and-up" *ngSwitchCase="'repeat_pending'">
            <p id="cancelTitle" class="c-text c-text--center c-text--heading c-text--s2 c-text--lg u-osb-md@up-to-md">
                {{ 'Booking.Instant.Timeout_Title' | translate }}
            </p>
            <div class="c-content u-no-pb">
                <p class="c-text c-text--center u-osb-lg">{{ 'Booking.Instant.Repeat_Pending_Description' | translate }}</p>
                <div class="o-grid o-grid--center-h u-osb-lg">
                    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
                        <button id="repeatRedirectHome" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.handleRedirectHome()">
                            {{ 'Common.Ok' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
		<!-- Status: timed out -->
		<div class="c-modal__content u-no-p@md-and-up" *ngSwitchDefault>
			<p class="c-text c-text--center c-text--heading c-text--s2 c-text--lg u-osb-md@up-to-md">{{ 'Booking.Instant.Timeout_Title' | translate }}</p>
			<div class="c-content u-no-pb">
				<p class="c-text c-text--center">{{ 'Booking.Instant.Try_Again' | translate }}</p>
				<p class="c-text c-text--center u-osb-lg">{{ 'Booking.Instant.Keep_Funds' | translate }}</p>
				<div class="o-grid o-grid--center-h u-osb-lg">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
						<button id="timeoutRedirectHome" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.handleRedirectHome()">{{ 'Booking.Instant.Keep' | translate }}</button>
					</div>
				</div>
				<div class="o-grid o-grid--center-h" *ngIf="!vm.isRefunded">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
						<button id="requestRefundButton" type="button" class="c-button c-button--link c-button--fit" (click)="vm.handleRefundInit()">{{ 'Booking.Instant.Refund' | translate }}</button>
					</div>
				</div>
			</div>
		</div>
		<loader-overlay *ngIf="vm.processing"></loader-overlay>
	</div>
</div>
